import {
  ChangeDetectionStrategy,
  Component,
  ViewContainerRef,
  OnInit,
  OnDestroy,
  Renderer2,
  ChangeDetectorRef,
  EventEmitter,
  HostListener,
  isDevMode,
  viewChild,
  ViewChild,
  signal,
  ElementRef,
  inject,
  DOCUMENT,
} from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet, RouterLinkActive, RouterLink } from '@angular/router';
import { AuthService, LoginMethod } from './services/Auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { OverlayService } from './services/Overlay/overlay.service';
import { PerformanceTrackerService } from './services/Shared/performance-tracker.service';
import { MrTranslatePipe } from './pipes/mr-translate.pipe';
import { getTokenRight, isEmptyObj } from './misc/functions';
import { ToastService } from './services/toast.service';
import { SpinnerService } from './services/Spinner/spinner.service';
import { firstValueFrom, fromEvent, interval, merge, Subscription } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { MessRegModalComponent } from './content/_components/_modals/messdaten-import/weichen-messdaten-import';
import { MessregAuswertungmodal } from './content/_components/_modals/messregauswertungmodal/messregauswertungmodal.component';
import { MessungModalComponent } from './content/_components/_modals/messdaten-import/strecken-messdaten-import';
import { environment } from 'src/environments/environment';
import { BasicStoreService } from './services/BasicStore/basic-store.service';
import { AnlagenComponent } from './content/Anlagen/anlagen.component';
import { APIService } from './services/APIService/api.service';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import shajs from 'sha.js';
import { MsalConfigService } from './services/msal-config.service';
import { BerichteConfigModalComponent } from './content/_components/_modals/berichteconfigmodal/berichte-config-modal.component';
import { EinstellungsmodalComponent } from './content/_components/_modals/einstellungsmodal/einstellungsmodal.component';
import { ImageSlideShowComponent } from './content/_components/_shared/media-slide-show/image-slide-show.component';
import { CommonModule, formatDate } from '@angular/common';
import { ClarityModule, ClrCommonStrings, ClrCommonStringsService, ClrForm } from '@clr/angular';
import { addClarityIconShapes } from './clarity-icons';
import { OVERLAY_COMPONENTS } from './overlay-record';
import { EULA_TEXT } from './eula-text';
import { GleisgrenzwertverletzungComponent } from './content/_components/_modals/gleisgrenzwertverletzung/gleisgrenzwertverletzung.component';
import { ReplikatSetupService } from './services/_offline/rep-setup.service';
import { IsRep } from './services/_offline/dexieDB';
import dayjs from 'dayjs';
import { OpenRepProgressService } from './content/_components/_modals/replikat-progress/open-rep-progress.service';
import { ReplikatProgressComponent } from './content/_components/_modals/replikat-progress/replikat-progress.component';
import { LicenseService } from './services/license.service';
import { ConfirmDialogComponent } from './content/_components/_shared/confirm-dialog/confirm-dialog.component';
import { ConfirmService } from './services/confirm.service';
import { AlertService } from './services/alert.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { BeschreibungDialogComponent } from './content/_components/_shared/beschreibung-dialog/beschreibung-dialog.component';
import { BeschreibungService } from './services/beschreibung.service';
import { versionInfo } from '../environments/version';
import { SharedDB } from './services/_offline/sharedDB';
import { ToastHostComponent } from './shared/toast-host/toast-host.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'mrpro-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    ImageSlideShowComponent,
    EinstellungsmodalComponent,
    MessRegModalComponent,
    MessungModalComponent,
    MessregAuswertungmodal,
    BerichteConfigModalComponent,
    MrTranslatePipe,
    GleisgrenzwertverletzungComponent,
    ReplikatProgressComponent,
    ConfirmDialogComponent,
    BeschreibungDialogComponent,
    ToastHostComponent,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  public viewContainerRef = inject(ViewContainerRef);
  oktaAuth = inject<OktaAuth>(OKTA_AUTH);
  private apiService = inject(APIService);
  private router = inject(Router);
  protected authservice = inject(AuthService);
  private overlayService = inject(OverlayService);
  private translate = inject(TranslateService);
  private renderer = inject(Renderer2);
  private toastr = inject(ToastService);
  private spinner = inject(SpinnerService);
  private swUpdateService = inject(SwUpdate);
  private changeDet = inject(ChangeDetectorRef);
  private mrTranslate = inject(MrTranslatePipe);
  private commonString = inject(ClrCommonStringsService);
  private sanitizer = inject(DomSanitizer);
  private basicStore = inject(BasicStoreService);
  private msalConfigService = inject(MsalConfigService);
  private confirmService = inject(ConfirmService);
  private beschreibungService = inject(BeschreibungService);
  private lic = inject(LicenseService);
  private alertService = inject(AlertService);
  private readonly sharedDB = inject(SharedDB);
  private readonly replikat = inject(ReplikatSetupService);
  protected readonly openRepProgress = inject(OpenRepProgressService);

  protected versionInfo = formatVersion();

  async copyToClipboard() {
    await navigator.clipboard.writeText(versionInfo.gitTag);
    this.toastr.info(this.mrTranslate.transform('Version Kopiert'));
  }

  title = 'app';
  logo: string = 'assets/mrprocloudlogo.svg';
  logoDark: string = 'assets/mrprocloudlogo-dark.svg';
  exitAvatar: string = 'assets/icons/exit.svg';

  isRep: boolean;
  DBName: string;

  showAppAlert: boolean = false;
  alerts: any[] = [];
  alerttyp: string = "'info'";
  alerttext: string = '';
  alertid: number = 0;
  alertbutton: string = 'OK';

  protected isMessungModalOpen = false;
  private readonly messungenuploadmodal = viewChild(MessungModalComponent);
  protected isGrenzwertModalOpen = false;
  private readonly messungengrenzwert = viewChild(GleisgrenzwertverletzungComponent);

  protected readonly isWeichenMessImport = signal(false);
  private readonly messreguploadmodal = viewChild(MessRegModalComponent);

  protected isMessregAuswertungModalOpen = false;
  private readonly messregauswertungdmodal = viewChild(MessregAuswertungmodal);
  private readonly routerOutlet = viewChild(RouterOutlet);
  protected readonly isBerichteModalOpen = signal(false);

  protected settingsModalOpen: boolean = false;
  @ViewChild(EinstellungsmodalComponent, { static: false })
  private settingsModal: EinstellungsmodalComponent;
  dosettingsModalOpen() {
    this.settingsModal.open(undefined);
  }

  protected readonly lang: string;

  protected isImageUrl = false;
  protected id: any;
  protected typ: any;
  protected files: any;
  protected images: any = [];
  protected fremdid: any;
  protected ostammid: any;
  protected pdffile: any;
  protected pdf_url: any;
  protected showpdf = false;
  protected filename = '';

  dataRefresh = new EventEmitter<any>();
  reloadTabIsReady = new EventEmitter<any>();

  isAppInDevMode() {
    return isDevMode();
  }

  protected theme: 'light' | 'dark' = 'light';
  private documentEl = inject(DOCUMENT);

  user: any;
  allowComponents = {
    map: false,
    statistic: false,
    wartung: false,
    projekt: false,
    begehung: false,
    messung: false,
    auftraege: false,
    anlagen: false,
    maengel: false,
    kalender: false,
    dashboard: false,
  };

  trialMode = false;
  trialDate: any = undefined;

  showoverlay;
  readonly overlay = viewChild('overlay', { read: ViewContainerRef });
  overlayref;
  overlayZ = 3;
  subscriptions: any = [];

  spinneractive: boolean;
  changePassword = false;
  showInfoBox = false;
  messregModalOpen = false;
  messungModalOpen = false;
  srcData: SafeResourceUrl;
  UseFAT: boolean = false;

  InfoBox: string = '';
  EULAdescription: string = EULA_TEXT;

  // Track if current route is the login page (or root redirecting to login) to suppress header
  isLoginRoute: boolean = false;

  currentConf: any;
  // settingsModalOpen = false;

  protected passwordGroup: UntypedFormGroup = new UntypedFormGroup({
    opw: new UntypedFormControl('', [Validators.required]),
    npw: new UntypedFormControl('', [Validators.required]),
    npw1: new UntypedFormControl('', [Validators.required]),
  });
  optPWkBuch: boolean = true;
  optPWgBuch: boolean = true;
  optPWZahl: boolean = true;
  optPWSonder: boolean = true;

  optPWMinL: number = 6;
  optAzkBuch: number = 1;
  optAzgBuch: number = 1;
  optAzZahl: number = 1;
  optAzSonder: number = 1;

  optPWExpire: String = '0';
  optPWExpireDays: number = 30;
  optPWHistoryCount: number = 0;
  optPWAdminMinL: number = 6;
  optAdminUsePW: boolean = false;
  optAdminMFA: boolean = false;
  checkAdminPWShowModal: boolean = false;
  googleCodeShow: boolean = false;
  @ViewChild('adminpw') adminpw: ElementRef;
  @ViewChild('input') input: ElementRef;

  private readonly clrForm = viewChild(ClrForm);

  constructor() {
    console.debug(environment.mode);

    addClarityIconShapes();
    this.lang = localStorage.getItem('language') || 'de';

    this.initNgSelect();
    this.initLanguage();
    this.initTokenSub();
    this.initOverlaySub();
  }

  private initNgSelect() {
    const config = inject(NgSelectConfig);
    config.placeholder = this.mrTranslate.transform('Auswählen oder Hinzufügen');
    config.addTagText = this.mrTranslate.transform('Hinzufügen');
    config.clearAllText = this.mrTranslate.transform('Löschen');
    config.notFoundText = this.mrTranslate.transform('Keine Einträge gefunden');
  }

  initSettings() {
    /*
    let dom = "2257f29edfa4372fe830a5d954e79bc56254472a91e75e0370da1abcc3497625";
    if (shajs("sha256").update(this.authservice.token.email.substring(this.authservice.token.email.indexOf("@") + 1, 100)).digest("hex") == dom)
    {
      return;
    }
    */

    this.apiService
      .getPWini()
      .pipe(first())
      .subscribe((val: any) => {
        if (!val) return;
        this.optPWkBuch = val.optPWkBuch;
        this.optPWgBuch = val.optPWgBuch;
        this.optPWZahl = val.optPWZahl;
        this.optPWSonder = val.optPWSonder;
        this.optPWMinL = val.optPWMinL;
        this.optAzkBuch = val.optAzkBuch;
        this.optAzgBuch = val.optAzgBuch;
        this.optAzZahl = val.optAzZahl;
        this.optAzSonder = val.optAzSonder;
        this.optPWExpire = val.optPWExpire;
        this.optPWExpireDays = val.optPWExpireDays;
        this.optPWHistoryCount = val.optPWHistoryCount;
        this.optPWAdminMinL = val.optPWAdminMinL;
        this.optAdminUsePW = val.optAdminUsePW;
        this.optAdminMFA = val.optAdminMFA;
      });

    // Also load INI options to set localStorage values like optUseFAT
    this.apiService
      .getINIOptions()
      .pipe(first())
      .subscribe((res: any) => {
        if (!res || !res.rows || !res.rows[0]) return;
        const iniOptions = res.rows[0];

        // Set optUseFAT in localStorage so FAT dropdown becomes visible
        const optUseFATValue = iniOptions.optUseFAT?.toString() || '0';
        localStorage.setItem('optUseFAT', optUseFATValue);

        // Also update component property and trigger change detection
        // This ensures menu items re-evaluate visibility after async settings load
        this.UseFAT = optUseFATValue === '1';
        this.changeDet.detectChanges();
      });
  }

  setAlert(items: any) {
    let v = items;
    switch (v['Alerttyp']) {
      case 1:
        this.alerttyp = 'danger';
        break;
      case 2:
        this.alerttyp = 'warning';
        break;
      case 3:
        this.alerttyp = 'success';
        break;
      default:
        this.alerttyp = 'info';
    }

    this.alerttext = v['Alerttext'];
    this.alertid = v['ID'];
    this.alertbutton = this.mrTranslate.transform('OK');
  }

  getactiveAlerts(alerts) {
    const confirmedAlerts = JSON.parse(localStorage.getItem('confirmedAlerts') || '[]');
    return alerts.filter(a => !confirmedAlerts.includes(a['ID']));
  }

  ngOnInit() {
    //! isImageUrl ist hier immer false
    // if (this.isImageUrl) return;

    this.alertService.startPolling();

    this.subscriptions.push(
      this.alertService.alerts$.subscribe(alerts => {
        if (this.showAppAlert == false) {
          if (alerts.length > 0) {
            this.alerts = this.getactiveAlerts(alerts);
            if (this.alerts.length > 0) {
              this.showAppAlert = true;
              this.setAlert(this.alerts[0]);
            }
          }
        }
      })
    );

    this.apiService.aud = '';
    this.apiService.tid = '';
    const msal = this.msalConfigService.getStoredConfig();
    if (msal) {
      this.apiService.aud = msal.appid;
      this.apiService.tid = msal.tenid;
    }
    /* THEME */
    this.initTheme();

    this.initRouterSub();
    this.isRep = IsRep();

    if (this.swUpdateService.isEnabled) {
      this.swUpdateService.versionUpdates.subscribe({
        next: async evt => {
          switch (evt.type) {
            case 'VERSION_READY': {
              try {
                const toast = this.toastr.info(
                  this.mrTranslate.transform('Installieren'),
                  this.mrTranslate.transform('Neues Update verfügbar'),
                  { disableTimeOut: true, closeButton: true }
                );
                await firstValueFrom(toast.onTap);
                await this.swUpdateService.activateUpdate();
                await this.authservice.refreshTokenTimer();

                document.location.reload();
              } catch (err) {
                console.error('Fehler beim Aktivieren des Updates:', err);
                document.location.reload();
              }
              break;
            }
            case 'VERSION_DETECTED': {
              console.debug('MR Pro: new Update.');
              break;
            }
            case 'NO_NEW_VERSION_DETECTED': {
              console.debug('MR Pro: kein Update...');
              break;
            }
            case 'VERSION_INSTALLATION_FAILED': {
              console.error('MR Pro Update fehlgeschlagen: ', evt);
              break;
            }
          }
        },
        error: console.error,
      });

      //* doppelt Meldung, vielleicht deswegen
      // this.swUpdateService.checkForUpdate().catch(err => console.error(err));
    }

    this.subscriptions.push(
      this.spinner.active.subscribe(val => {
        this.spinneractive = val;
        this.changeDet.detectChanges();
      })
    );
  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.alertService.stopPolling();
    this.subscriptions.forEach((subs: Subscription) => {
      subs.unsubscribe();
    });
  }

  async clearReplikat() {
    const ok = await this.confirmService.warning(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie das Replikat löschen wollen?')
    );
    if (!ok) return;
    this.spinner.enable();
    if (await this.replikat.checkIfOnline()) await this.replikat.stopReplicate('withoutChanges');
    this.spinner.disable();
  }

  onCloseAlert(typ: number) {
    if (this.alertbutton == this.mrTranslate.transform('zur Ansicht wechseln')) {
      this.alertSwitchToView(this.alerts[0].type);
      this.alerts = this.alerts.slice(1);
    } else {
      const confirmedAlerts = JSON.parse(localStorage.getItem('confirmedAlerts') || '[]');

      if (typ == 1) {
        confirmedAlerts.push(this.alertid);
      }
      localStorage.setItem('confirmedAlerts', JSON.stringify(confirmedAlerts));

      this.alerts = this.alerts.slice(1);
      this.showAppAlert = this.alerts.length > 0;

      if (this.alerts.length > 0) {
        this.setAlert(this.alerts[0]);
      }

      setTimeout(() => {}, 1);
    }
  }

  private initTokenSub() {
    this.subscriptions.push(
      this.authservice
        .get$token()
        .pipe(first(vl => vl && vl.vorname))
        .subscribe(val => {
          if (val) {
            this.initSettings();

            if (val.email) {
              sessionStorage.setItem('User', val.email);
              sessionStorage.setItem('UserName', val.username);
            }
            if (val.db) {
              localStorage.setItem('DB', val.db);
              this.DBName = val.db.substring(6).replace('_test', ' (Testdatenbank)').replace('_', ' ');
              this.DBName = this.DBName.replace(new RegExp('\\b\\w{1,3}\\b', 'g'), str => str.toUpperCase()).replace(
                new RegExp('(^|\\s)[a-z]', 'g'),
                str => str.toUpperCase()
              );
              localStorage.setItem('FormatCurDB', this.DBName);
            }
            this.isRep = IsRep();
            this.apiService.isRep = this.isRep;

            if (this.isRep) {
              this.logo = 'assets/mrprocloudlogo-rep.svg';
              this.logoDark = 'assets/mrprocloudlogo-dark-rep.svg';
            }

            try {
              val.rights = JSON.parse(this.authservice.decrypt(localStorage.getItem('rights'))); 
            } catch (error) {}
            if (val.rights) {
              this.allowComponents = {
                map: this.authservice.canAccessGISMap() && !this.isRep,
                statistic: getTokenRight(val.rights.view, 'AllowVSTAT'),
                anlagen: getTokenRight(val.rights.view, 'AllowVANL'),
                maengel: getTokenRight(val.rights.view, 'AllowVMANG'),
                kalender: getTokenRight(val.rights.view, 'AllowVKAL'),
                dashboard: getTokenRight(val.rights.view, 'AllowVDASH'),
                wartung: getTokenRight(val.rights.view, 'AllowVWART'),
                projekt: getTokenRight(val.rights.view, 'AllowVPOJM'),
                messung: getTokenRight(val.rights.view, 'AllowVMESS'),
                auftraege: getTokenRight(val.rights.view, 'AllowVAuftr'),
                begehung: getTokenRight(val.rights.view, 'AllowVBeg'),
              };

              
              //Zusätzliche Prüfung: Wenn User nicht Recht "AllowVADTL" hat (zeige Anlage Detailansicht), abmelden. Rechte müssen aktualisiert werden
              try {
                if (getTokenRight(val.rights.view, 'AllowVADTL') === undefined) {
                  this.toastr.warning(this.mrTranslate.transform("Rechte müssen aktualisiert werden. Dafür müssen Sie abgemeldet werden. Abmelden in 10 Sekunden..."), "Rechtemanagement", { disableTimeOut: true });
                  setTimeout(() => {
                    this.logout();
                  }, 10000);
                }
              } catch (error) { }

              if (this.isRep)
                this.sharedDB.GetRepType().then(funk => {
                  this.allowComponents.wartung &&= !funk || funk == 'Wartung';
                  this.allowComponents.begehung &&= !funk || funk == 'Begehung';
                });

              // Machen aktuell zu viele Probleme, wenn eine Reihe oben angezeigt wird. GISMAP überdeckt das Branding dann und Detailview geht auch zu weit hoch
              // Problem ist behoben MR 21.20.2026
              // Es fehlt noch die Anpassung der Overlays
              var info = val?.auftragInfo ? JSON.parse(val.auftragInfo) : 'null';
              if (getTokenRight(val.rights.program, 'AllowPAuftrGen') && info.gen > 0) {
                this.showAppAlert = true;
                this.alerts.push({
                  ID: null,
                  type: 'gen',
                  text:
                    info.gen + this.mrTranslate.transform(' Aufträge sind im Status "Genehmigung". Bitte überprüfen!'),
                });
                this.alerttyp = 'info';
                this.alerttext =
                  info.gen + this.mrTranslate.transform(' Aufträge sind im Status "Genehmigung". Bitte überprüfen!');
                this.alertid = null;
                this.alertbutton = this.mrTranslate.transform('zur Ansicht wechseln');
              }
              if (getTokenRight(val.rights.program, 'AllowPAuftrRueck') && info.rueck > 0) {
                this.showAppAlert = true;
                this.alerts.push({
                  ID: null,
                  type: 'rueck',
                  text:
                    info.rueck + this.mrTranslate.transform(' Aufträge sind im Status "Rückmelden". Bitte überprüfen!'),
                });
                this.alerttyp = 'info';
                this.alerttext =
                  info.rueck + this.mrTranslate.transform(' Aufträge sind im Status "Rückmelden". Bitte überprüfen!');
                this.alertid = null;
                this.alertbutton = this.mrTranslate.transform('zur Ansicht wechseln');
              }

              this.InfoBox =
                `Lizenziert für: ` +
                val.rights.KundeName +
                `\n\nLizenznehmer: ` +
                val.rights.ClintRegName +
                `\n\nMaximale Anzahl Benutzer: ` +
                val.rights.MaxUser;
            }
            this.trialMode = val.trial === true;
            this.trialDate = val.trialDate;
            this.user = {
              vorname: val.vorname,
              nachname: val.nachname,
              mobil: val.mobil,
              image: undefined,
              svg: undefined,
              status: val.rights.status,
              rights: val.rights,
            };

            let url = window.location.toString();
            if (url.toLowerCase().indexOf('/image?') > -1 || url.toLowerCase().indexOf('/pdf?') > -1) {
              return;
            }

            // Skip automatic navigation here to prevent conflicts with auth service navigation
            // The auth service now handles all post-login navigation logic
            console.log('🔧 [APP-COMPONENT] Skipping automatic navigation - handled by auth service');
          }

          // Fix: Set UseFAT immediately from localStorage to avoid race condition with menu rendering
          let optFat = localStorage.getItem('optUseFAT');
          this.UseFAT = optFat === '1';

          // Load user avatar image
          const userimg = localStorage.getItem('userimg');
          if (userimg && userimg.length > 0) {
            if (userimg.includes('svg') || userimg.includes('<')) {
              // SVG content (either raw SVG or contains tags)
              this.user.svg = userimg;
            } else {
              // Base64 image data
              this.user.image = userimg;
            }
          }
          // Note: if userimg is null/empty, user.svg stays undefined and getSVGImageUrl will generate default avatar
        })
    );
    if (false /* production from shared.service.ts, that is always false */) {
      this.subscriptions.push(
        this.authservice
          .getLoggedIn()
          .pipe(first(vl => vl === true))
          .subscribe(val => {
            if (val && !this.user && isEmptyObj(this.user)) {
              window.onbeforeunload = function (e) {
                var confirmationMessage = 'o/';
                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Webkit, Safari, Chrome
              };
            }
          })
      );
    }

    this.subscriptions.push(
      interval(5000).subscribe(n => {
        if (this.isRep) return;
        this.checkRefreshAndLogout();
      })
    );

    this.subscriptions.push(
      merge(fromEvent(document, 'mousedown')).subscribe(async n => {
        //Ursprünglich war hier eine Prüfung bei jedem Mausklick, ob der Timer abgelaufen ist und wenn ja, wird man ausgeloggt.
        //Das ist redundant, da wir exakt das schon automatisch alle 5 sekunden prüfen.
        //Stattdessen wird jetzt geprüft, ob man innerhalb der letzten Stunde des Timer-Countdowns aktiv ist, und wenn ja, dann setz wieder auf 2 Stunden.
        if (this.isRep || window.location.href.endsWith('/login')) return;
        let now = Math.floor(Date.now() / 1000);
        let timeDiff = parseInt(localStorage.getItem('jwt_exp')) - now;
        if (timeDiff < 3600) {
          // Refresh MRPro token
          this.authservice.refreshTokenTimer();

          // Also renew Okta tokens if user logged in via Okta to prevent IdP session expiration
          if (this.authservice.loginMethod === LoginMethod.Okta) {
            try {
              const accessToken = await this.oktaAuth.tokenManager.get('accessToken');
              const idToken = await this.oktaAuth.tokenManager.get('idToken');

              // Check if Okta tokens exist and will expire soon (within 30 minutes)
              const oktaTokenExpiryThreshold = 1800; // 30 minutes in seconds
              if (accessToken && accessToken.expiresAt) {
                const oktaTimeDiff = accessToken.expiresAt - now;
                if (oktaTimeDiff < oktaTokenExpiryThreshold) {
                  console.log('🔄 Renewing Okta tokens due to user activity...');
                  await this.oktaAuth.tokenManager.renew('accessToken');
                  if (idToken) {
                    await this.oktaAuth.tokenManager.renew('idToken');
                  }
                  console.log('✅ Okta tokens renewed successfully');
                }
              }
            } catch (err) {
              console.warn('⚠️ Failed to renew Okta tokens:', err);
              // Don't logout on renewal failure - let the normal expiry flow handle it
            }
          }
        }
      })
    );
  }

  private initOverlaySub() {
    this.subscriptions.push(
      this.overlayService.getOverlay().subscribe(val => {
        let overLayConf = val;
        if (overLayConf !== null) {
          this.showoverlay = true;
          const overlay = this.overlay();
          if (overlay.length == 0) {
            this.currentConf = overLayConf;
            this.overlayZ = typeof overLayConf.zIndex !== undefined ? overLayConf.zIndex : 3;
            overlay.clear();

            this.overlayref = overlay.createComponent(OVERLAY_COMPONENTS[overLayConf.overlay]);
            let ol = this.overlayref.instance;
            ol.data = overLayConf;
            this.subscriptions.push(
              ol.closedialog.subscribe((val: boolean) => {
                if (val) {
                  this.showoverlay = false;
                  this.overlay().clear();
                  if (
                    (this.currentConf.overlay == 'openAdressbook' ||
                      overLayConf.overlay == 'openUsermanagement' ||
                      this.currentConf.overlay == 'abnahmeProtokoll' ||
                      this.currentConf.isTopOverlay) &&
                    this.currentConf.recallConf
                  ) {
                    this.overlayService.setOverlay(this.currentConf.recallConf);
                    // if (this.currentConf.overlay == "createassignment") {}
                    // ? recallConf vom vorletzten Overlay ?
                  }
                }
              })
            );
          } else {
            if (overLayConf.overlay == 'profileviewer') {
              this.overlayref.instance.changeIndexToPos(overLayConf.start);
            }

            if (
              overLayConf.overlay == 'openAdressbook' ||
              overLayConf.overlay == 'openUsermanagement' ||
              overLayConf.overlay == 'abnahmeProtokoll' ||
              overLayConf.overlay == 'viewAuftrag' ||
              overLayConf.isTopOverlay
            ) {
              overlay.clear();
              val.recallConf = this.currentConf;
              if (val.recallData) {
                val.recallConf.recalledData = val.recallData;
                delete val.recallData;
              }
              this.overlayService.setOverlay(val);
            }
          }
        }
      })
    );
    this.subscriptions.push(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(val => {
        this.showoverlay = false;
        this.overlay().clear();
        const nav = val as NavigationEnd;
        const url = (nav.urlAfterRedirects || nav.url || '').toLowerCase();
        this.isLoginRoute = url === '/login' || url.startsWith('/login?') || url === '/';

        // Redirect: Falls bereits eingeloggt (egal welche Methode) und Route ist Root oder /login, weiterleiten
        if (this.isLoginRoute && this.authservice.isLoggedIn()) {
          // External-only Okta users and MSAL (Microsoft) users should always go to /anlagen (no GIS map)
          if (this.authservice.isExternalOnlyOktaUser() || this.authservice.isMicrosoftLogin()) {
            this.router.navigateByUrl('/anlagen');
          } else {
            this.authservice.setRoute();
          }
        }
      })
    );
  }

  private initRouterSub() {
    this.subscriptions.push(
      this.router.events
        .pipe(filter(event => event instanceof NavigationStart || event instanceof NavigationEnd))
        .subscribe(event => {
          if (event instanceof NavigationStart) {
            if (event.url.toLowerCase().indexOf('/image?') > -1) {
              this.id = '';
              this.typ = '';
              this.files = '';

              let url = window.location.toString();
              let params = url?.split('?')[1]?.split('&');
              let obj = {};
              params?.forEach(el => {
                let [k, v] = el?.split('=');
                obj[k] = v;
              });

              if (obj['id'] != undefined) {
                this.id = obj['id'];
              }

              if (obj['typ'] != undefined) {
                this.typ = obj['typ'];
              }

              if (obj['files'] != undefined) {
                this.files = decodeURI(obj['files']);
              }

              if (this.id == '') {
                this.toastr.error(this.mrTranslate.transform('URL ist ungültig.'));
                return;
              }
              if (this.typ == '') {
                this.toastr.error(this.mrTranslate.transform('URL ist ungültig.'));
                return;
              }
              if (this.files == '') {
                this.toastr.error(this.mrTranslate.transform('URL ist ungültig.'));
                return;
              }

              this.apiService
                .getApiImages(this.id, this.typ, this.files)
                .pipe(first())
                .subscribe((res: any) => {
                  if (res?.success == true) {
                    this.images = res.files;
                  } else {
                    const text = this.mrTranslate.transform('Bilder konnten nicht geladen werden');
                    this.toastr.error(text + ' ' + res?.message);
                    this.images = [];
                  }
                });

              this.isImageUrl = true;
              return;
            }

            if (event.url.toLowerCase().indexOf('/pdf?') > -1) {
              this.id = '';
              this.fremdid = '';
              this.ostammid = '';

              let url = window.location.toString();
              let params = url?.split('?')[1]?.split('&');
              let obj = {};
              params?.forEach(el => {
                let [k, v] = el?.split('=');
                obj[k] = v;
              });

              if (obj['id'] != undefined) {
                this.id = obj['id'];
              }

              if (obj['ostammid'] != undefined) {
                this.ostammid = obj['ostammid'];
              }

              if (obj['fremdid'] != undefined) {
                this.fremdid = obj['fremdid'];
              }

              if (this.id == '') {
                this.toastr.error(this.mrTranslate.transform('URL ist ungültig.'));
                return;
              }
              if (this.ostammid == '' && this.fremdid == '') {
                this.toastr.error(this.mrTranslate.transform('URL ist ungültig.'));
                return;
              }

              this.apiService
                .getApiPdfDok(this.id, this.ostammid, this.fremdid)
                .pipe(first())
                .subscribe((res: any) => {
                  if (res != null) {
                    this.pdffile = res;
                    let url = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.pdffile));
                    this.pdf_url = url;
                    this.filename = this.mrTranslate.transform('Inspektionsbericht');

                    this.showpdf = true;
                  } else {
                    const text = this.mrTranslate.transform('PDF konnten nicht geladen werden');
                    this.toastr.error(text + ' ' + res?.message);
                    this.pdffile = '';
                  }
                });

              this.isImageUrl = true;
              return;
            }

            PerformanceTrackerService.startComponentLoad(event.url);
          } else if (event instanceof NavigationEnd) {
            PerformanceTrackerService.endComponentLoad(event.url);
          }
        })
    );
  }

  //#region Theme
  private initTheme() {
    if (localStorage.getItem('theme') == 'dark') {
      this.toggleTheme();
    }
  }

  toggleTheme() {
    this.theme = this.theme == 'light' ? 'dark' : 'light';
    localStorage.setItem('theme', this.theme);
    this.renderer.setAttribute(this.documentEl.body, 'cds-theme', this.theme);
  }
  //#endregion

  checkRefreshAndLogout() {
    let refresh = this.authservice.getRefreshToken();
    let diff: number = 0;

    if (refresh.expiresAt && refresh.passphrase) {
      // //Wenn wir schon ausgeloggt sind, brauchen wir nicht zu refreshen.
      // if(window.location.href.endsWith("/login")) refresh.expiresAt = Math.floor(Date.now() / 1000);
      diff = refresh.expiresAt - Math.floor(Date.now() / 1000);
    }

    if (!this.authservice.isLoggedIn() && refresh?.expiresAt && refresh?.passphrase) {
      if (diff <= 0) {
        setTimeout(() => {
          this.authservice.logout();
        });
      }
    }
  }

  //#region Sprache
  private initLanguage() {
    this.translate.addLangs(['de', 'en', 'fr', 'it', 'nl', 'pt', 'ru', 'tr']);
    const langcode = this.lang;

    this.translate.use(langcode).subscribe(() => {
      dayjs.locale(langcode);

      this.commonString.localize({
        pickColumns: this.mrTranslate.transform('Spalten verwalten'),
        showColumns: this.mrTranslate.transform('Spalten anzeigen'),
        selectAll: this.mrTranslate.transform('Alle auswählen'),
      });
    });
  }

  async changeLanguage(langcode: string) {
    localStorage.setItem('language', langcode);
    const ok = await this.confirmService.info(
      this.mrTranslate.transform(
        'Ein Wechsel der Sprache erfordert ein Neuladen der Seite. Möchten Sie die Seite jetzt aktualisieren?'
      )
    );
    if (ok) window.location.reload();
  }
  //#endregion

  verifyGoogleCode() {
    if (this.input.nativeElement.value.toString().length != 6) {
      this.toastr.error(this.mrTranslate.transform('Bestätigungscode ist ungültig'));
      return;
    }

    let items = {
      code: this.input.nativeElement.value,
      email: this.authservice.token.email,
      db: this.authservice.token.db,
    };

    this.apiService.verifyGoogleCode(items, this.authservice.tempdata.token).subscribe((data: any) => {
      if (data) {
        if (data.error != undefined) {
          this.toastr.error(this.mrTranslate.transform(data.error));
          return;
        } else {
          if (data.success) {
            this.googleCodeShow = false;
            this.overlayService.setOverlay({
              overlay: 'openUsermanagement',
              zIndex: 8,
            });
            return;
          } else {
            this.toastr.error(this.mrTranslate.transform('Code ist ungültig'));

            this.input.nativeElement.value = '';
            setTimeout(() => {
              this.input.nativeElement.focus();
            }, 20);

            return;
          }
        }
      } else {
        this.toastr.error(this.mrTranslate.transform('Es ist ein Fehler aufgetreten.'));
        return;
      }
    });
  }

  checkAdminPW(event) {
    let pw = this.adminpw.nativeElement.value.toString();
    if (pw == '') {
      this.toastr.error(this.mrTranslate.transform('Geben Sie Ihr Passwort ein.'));
      return;
    }
    let pwhash = { pwhash: shajs('sha256').update(pw).digest('hex') };

    this.apiService
      .CheckPWAdmin(pwhash)
      .pipe(first())
      .subscribe((val: any) => {
        if (val.status == 'OK') {
          this.checkAdminPWShowModal = false;

          if (this.optAdminMFA) {
            this.googleCodeShow = true;

            setTimeout(() => {
              this.input.nativeElement.focus();
            }, 20);
          } else {
            this.overlayService.setOverlay({
              overlay: 'openUsermanagement',
              zIndex: 8,
            });
          }
        } else {
          this.toastr.error(this.mrTranslate.transform(val.text));
        }
      });
  }

  //#region Overlays
  openUserManagement() {
    if (this.optAdminUsePW) {
      this.checkAdminPWShowModal = true;
      this.adminpw.nativeElement.value = '';
    } else {
      this.overlayService.setOverlay({
        overlay: 'openUsermanagement',
        zIndex: 8,
      });
    }
  }

  openWartungsVerwaltung() {
    this.overlayService.setOverlay({
      overlay: 'wartungsVerwaltung',
    });
  }

  openMangelverteilung() {
    this.overlayService.setOverlay({
      overlay: 'mangelverteilung',
    });
  }

  openKomponenteneditdialog() {
    this.overlayService.setOverlay({
      overlay: 'komponenteneditdialog',
    });
  }

  openPruefungenverwaltenDialog() {
    this.overlayService.setOverlay({
      overlay: 'pruefungenverwaltendialog',
    });
  }

  openSonderinspektionsListedialog() {
    this.dataRefresh.subscribe(_ => {
      this.basicStore.reloadTabs({ emitter: this.reloadTabIsReady });
      const component = this.routerOutlet().component;
      if (component instanceof AnlagenComponent) {
        component.reloadAnlagen(this.reloadTabIsReady);
      }
    });
    this.overlayService.setOverlay({
      overlay: 'sonderinspektionslistedialog',
      dataRefresh: this.dataRefresh,
    });
  }

  openBegehungsVerwaltung() {
    this.overlayService.setOverlay({
      overlay: 'begehungsVerwaltung',
    });
  }

  openStammdatenDialog() {
    this.overlayService.setOverlay({
      overlay: 'openStammdatenDialog',
      zIndex: 8,
    });
  }

  openObjekttypManagement() {
    this.overlayService.setOverlay({
      overlay: 'openObjekttypmanagement',
      zIndex: 8,
    });
  }

  openAddressbook() {
    this.overlayService.setOverlay({
      overlay: 'openAdressbook',
      zIndex: 8,
    });
  }

  openFormcreation() {
    this.overlayService.setOverlay({
      overlay: 'createForm',
      zIndex: 8,
    });
  }

  /**
   * True if user has admin or internal groups (not purely external)
   */
  private isAdminOrInternal(): boolean {
    // Use auth service method - returns true when NOT external only
    return !this.authservice?.isExternalOnlyOktaUser();
  }

  /**
   * External-only Okta customer: user logged in via Okta and has no admin or internal groups.
   * Used to limit topbar navigation.
   */
  public get isExternalOnlyOkta(): boolean {
    return this.authservice?.isExternalOnlyOktaUser() ?? false;
  }

  /**
   * FAT UI limitation mode: disable/hide topbar/menu entries in FAT context not only for external-only Okta,
   * but also for internal/admin while working in FAT. Uses DB flag from token (db === 'mrpro_fat') or local optUseFAT.
   */
  public get isFatUiLimited(): boolean {
    const token: any = this.authservice?.token;
    const dbIsFat = token?.db === 'mrpro_fat';
    const fatFeature = localStorage.getItem('optUseFAT') === '1' || this.UseFAT === true;
    const inFatContext = dbIsFat || fatFeature;
    if (!inFatContext) return false;
    // In FAT, we limit for everyone except pure admins if we want to keep access minimal.
    // Keep behavior: limit for external-only, and also limit for internal/admin when in FAT mode per requirement.
    return true;
  }

  /**
   * Controls visibility of "Vorlagen für Werksabnahme erstellen" in main menu
   */
  public canSeeWerksabnahmeTemplates(): boolean {
    return this.UseFAT && this.isAdminOrInternal();
  }

  // Prevent navigation for disabled topbar links while keeping hover tooltips
  public blockDisabledNav(event: Event): void {
    if (this.isFatUiLimited) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  //#endregion

  //#region Modals
  openMessregAuswertungModal() {
    this.isMessregAuswertungModalOpen = true;
    setTimeout(() => {
      this.messregauswertungdmodal().open();

      this.messregauswertungdmodal().onOK.subscribe(res => {
        if (res == true) {
        }
        this.messregauswertungdmodal().close();
      });
    });
  }

  openGleisToleranzAusfallBerechnung() {
    this.isGrenzwertModalOpen = true;
    setTimeout(() => {
      let inData = {
        isDarkThemeAktiv: this.theme,
      };
      this.messungengrenzwert().open(inData);

      this.messungengrenzwert().onOK.subscribe(res => {
        if (res == true) {
        }
        //
        this.messungengrenzwert().close();
        this.isGrenzwertModalOpen = false;
      });
    });
  }

  openMessungModal() {
    this.isMessungModalOpen = true;
    setTimeout(() => {
      let inData = {
        isDarkThemeAktiv: this.theme,
      };

      this.messungenuploadmodal().open(inData);

      this.messungenuploadmodal().onOK.subscribe(res => {
        if (res == true) {
          this.basicStore.reloadTabs({ emitter: this.reloadTabIsReady });
          const component = this.routerOutlet().component;
          if (component instanceof AnlagenComponent) {
            component.reloadAnlagen(this.reloadTabIsReady);
          }
        }
        if (this.messungenuploadmodal().modalOpen) this.messungenuploadmodal().close();
      });
    });
  }

  reload() {
    this.basicStore.reloadTabs({ emitter: this.reloadTabIsReady });
    const component = this.routerOutlet().component;
    if (component instanceof AnlagenComponent) {
      component.reloadAnlagen(this.reloadTabIsReady);
    }
  }

  openLinienverwaltungDialogComponent() {
    this.overlayService.setOverlay({
      overlay: 'linienverwaltungMenu',
      zIndex: 9,
    });
  }

  openChecklistenDialogComponent() {
    this.overlayService.setOverlay({
      overlay: 'checklistenMenu',
      zIndex: 9,
    });
  }

  openTrassierungseditor() {
    this.overlayService.setOverlay({
      overlay: 'trassierungseditor',
      zIndex: 9,
    });
  }

  openStatistik() {
    this.overlayService.setOverlay({
      overlay: 'statistik',
      zIndex: 8,
    });
  }

  openSystemManagement() {
    this.overlayService.setOverlay({
      overlay: 'systemManagementDialog',
      zIndex: 8,
    });
  }

  openBauformVerwaltung() {
    this.overlayService.setOverlay({ overlay: 'bauformverwaltung' });
  }

  //#endregion

  getImageSaveUrl(image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  getSVGImageUrl(image) {
    // Handle undefined/null/empty input - generate default avatar with user initials
    if (!image) {
      const initials = this.user ? (this.user.vorname?.charAt(0) || '') + (this.user.nachname?.charAt(0) || '') : '?';
      image = this.generateDefaultAvatarSvg(initials.toUpperCase() || '?');
    }
    let base64string = btoa(image);
    return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/svg+xml;base64,${base64string}`);
  }

  /**
   * Generate a default SVG avatar with user initials
   */
  private generateDefaultAvatarSvg(letters: string): string {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <circle cx="20" cy="20" r="20" fill="#0072a3"/>
      <text x="20" y="26" text-anchor="middle" fill="white" font-size="16" font-family="Arial, sans-serif" font-weight="bold">${letters}</text>
    </svg>`;
  }

  getSVGImage(image) {
    return this.sanitizer.bypassSecurityTrustHtml(`${image}`);
  }

  alertSwitchToView(type) {
    this.router.navigateByUrl('/auftraege');
  }

  async logout() {
    // try {
    //   await this.oktaAuth.signOut();
    // } catch (error) {console.log("Fehler bei OKTA-Logout!!!:" + error)}
    if (this.isRep) {
      const ok = await this.confirmService.info(
        this.mrTranslate.transform(
          'Wenn Sie sich in einem Replikat abmelden, müssen Sie wieder online sein um sich anzumelden. Wollen Sie das wirklich?'
        )
      );
      if (ok) await this.authservice.logout();
    } else await this.authservice.logout();
  }

  changePasswordClick() {
    this.changePassword = true;
  }

  setNewPassword(event): void {
    this.clrForm().markAsTouched();
    if (this.passwordGroup.valid) {
      let opw = this.passwordGroup.value.opw;
      let npw = this.passwordGroup.value.npw;
      let npw1 = this.passwordGroup.value.npw1;

      if (opw == npw) {
        this.toastr.info(
          this.mrTranslate.transform(
            'Altes und neues Passwort ist gleich. Passwort wurde nicht geändert, bitte ändern Sie Ihre Eingabe.'
          )
        );
        return;
      }

      if (npw != npw1) {
        this.toastr.error(
          this.mrTranslate.transform('Passwort und Wiederholung stimmen nicht überein, bitte ändern Sie Ihre Eingabe.')
        );
        return;
      }

      let validPW = this.validatePassword(npw);
      if (validPW != '') {
        this.toastr.error(this.mrTranslate.transform(validPW), '', {
          enableHtml: true,
        });
        return;
      }

      let pwhash_old = shajs('sha256').update(opw).digest('hex');
      let pwhash_new = shajs('sha256').update(npw).digest('hex');

      let editUser = {
        status: 'changepassword',
        pwhash_old: pwhash_old,
        pwhash_new: pwhash_new,
        id: 0,
        optPWExpire: this.optPWExpire,
        optPWExpireDays: this.optPWExpireDays,
        optPWHistoryCount: this.optPWHistoryCount,
      };

      this.apiService
        .updateUser(editUser)
        .pipe(first())
        .subscribe((val: any) => {
          if (val.message.toLowerCase() === 'ok') {
            this.toastr.success(this.mrTranslate.transform('Passwort wurde erfolgreich geändert…'));
            this.changePassword = false;

            this.passwordGroup.value.opw = '';
            this.passwordGroup.value.npw = '';
            this.passwordGroup.value.npw1 = '';
          } else {
            if (val.text) {
              this.toastr.error(this.mrTranslate.transform(val.text));
            } else {
              this.toastr.error(this.mrTranslate.transform('Leider ist ein Fehler aufgetreten.'));
            }
          }
        });
    }
  }

  validatePassword(pw: string) {
    let dev = this.authservice.token.rights.dev;
    if (dev) {
      this.optAzkBuch = 2;
      this.optAzgBuch = 2;
      this.optAzSonder = 3;
      this.optAzZahl = 3;
    }
    let errortext = this.mrTranslate.transform('Das Passwort entspricht nicht den Sicherheitsrichtlinien') + ':</br>';
    if (dev) {
      errortext += this.mrTranslate.transform('Anzahl Zeichen') + ': 14 </br>';
    } else if (this.authservice.token.rights.showusers == true) {
      errortext += this.mrTranslate.transform('Anzahl Zeichen') + ': ' + this.optPWAdminMinL.toString() + '</br>';
    } else {
      errortext += this.mrTranslate.transform('Anzahl Zeichen') + ': ' + this.optPWMinL.toString() + '</br>';
    }
    if (this.optPWkBuch || dev) {
      errortext += this.mrTranslate.transform('Anzahl Kleinbuchstaben') + ': ' + this.optAzkBuch.toString() + '</br>';
    }
    if (this.optPWgBuch || dev) {
      errortext += this.mrTranslate.transform('Anzahl Grossbuchstaben') + ': ' + this.optAzgBuch.toString() + '</br>';
    }
    if (this.optPWSonder || dev) {
      errortext += this.mrTranslate.transform('Anzahl Sonderzeichen') + ': ' + this.optAzSonder.toString() + '</br>';
    }
    if (this.optPWZahl || dev) {
      errortext += this.mrTranslate.transform('Anzahl Zahlen') + ': ' + this.optAzZahl.toString() + '</br>';
    }

    if (pw == undefined) {
      return errortext;
    }

    if (pw == '') {
      return errortext;
    }

    let hasNumber = new RegExp('[0-9]');
    let hasUpperChar = new RegExp('[A-Z]');
    let hasLowerChar = new RegExp('[a-z]');
    let hasSymbols = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/);
    let countUpper: number = 0;
    let countLower: number = 0;
    let countNumber: number = 0;
    let countSymbols: number = 0;

    if (this.authservice.token.rights.showusers) {
      if (pw.length < this.optPWAdminMinL) {
        return errortext;
      }
    } else if (dev && pw.length < 14) {
      return errortext;
    } else if (pw.length < this.optPWMinL) {
      return errortext;
    }

    if (this.optPWkBuch || dev) {
      if (!pw.match(/[a-z]/)) {
        return errortext;
      }
      countLower = (pw.match(/[a-z]/g) || []).length;
      if (this.optAzkBuch > countLower) {
        return errortext;
      }
    }

    if (this.optPWgBuch || dev) {
      if (!pw.match(/[A-Z]/)) {
        return errortext;
      }
      countUpper = (pw.match(/[A-Z]/g) || []).length;
      if (this.optAzgBuch > countUpper) {
        return errortext;
      }
    }

    if (this.optPWZahl || dev) {
      if (!pw.match(/[0-9]/)) {
        return errortext;
      }
      countNumber = (pw.match(/[0-9]/g) || []).length;
      if (this.optAzZahl > countNumber) {
        return errortext;
      }
    }

    if (this.optPWSonder || dev) {
      if (!pw.match(hasSymbols)) {
        return errortext;
      }
      try {
        countSymbols = pw.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g).length;
        if (this.optAzSonder > countSymbols) {
          return errortext;
        }
      } catch (e) {
        return errortext;
      }
    }

    return '';
  }
}

function formatVersion(): string {
  const { tag, commitsAhead, buildDate } = versionInfo;
  if (!buildDate) return tag;
  return `${tag} (+ ${commitsAhead}) - ${formatDate(buildDate, 'short', 'de')}`;
}
